// src/components/Spinner.jsx

import React from 'react';
import {MdLocalShipping} from "react-icons/md";

const Spinner = () => {

    return (
        <div className="flex flex-col justify-center items-center h-96 gap-4">
            <div className="relative">
                <div className="animate-spin rounded-full h-16 w-16 border-4 border-blue-200 border-t-blue-600"></div>
                <div className="absolute inset-0 flex items-center justify-center">
                    <MdLocalShipping className="text-blue-600 text-xl" />
                </div>
            </div>
            <p className="text-gray-500 text-sm font-medium">در حال بارگذاری سفارشات...</p>
        </div>
    );
};

export default Spinner;